<template>
  <div
    class="ebook-header"
    :class="{ 'ebook-header--has-cover': hasCover }"
    :style="headerStyle"
  >
    <div class="ebook-header__content content-container">
      <div class="container-fluid">
        <img
          v-if="!hasCover"
          class="ebook-header__logo"
          :src="$setup.partnerLogo"
          :alt="setup.name"
        />
        <h1 class="page-title ebook-header__title">
          {{ setup.name }}
        </h1>
        <p v-if="setup.description" class="ebook-header__description">
          {{ setup.description }}
        </p>
      </div>
    </div>
    <div v-if="hasCover" class="ebook-header__overlay"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import isMobile from "ismobilejs";

export default {
  name: "EbookHeader",
  computed: {
    ...mapState(["setup"]),
    bannerUrl() {
      if (isMobile().any && this.setup.cover_mobile) {
        return this.setup.cover_mobile;
      }
      return this.setup.cover || null;
    },
    hasCover() {
      return !!this.bannerUrl;
    },
    headerStyle() {
      if (this.hasCover) {
        return `background-image: url("${this.bannerUrl}");`;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.ebook-header {
  position: relative;
  background-size: cover;
  background-position: center;
  background-color: #151823;
  color: white;
  min-height: 280px;

  &--has-cover {
    padding-top: 28.875%;
    min-height: unset;

    @media screen and (max-width: 991px) {
      padding-top: 89%;
    }

    @media screen and (max-width: 576px) {
      padding-top: 132%;
    }
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 32px;
  }

  &__logo {
    max-height: 48px;
    max-width: 160px;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;

    @media screen and (max-width: 768px) {
      font-size: 24px;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 1.6;
    margin: 0;
    max-width: 600px;
    opacity: 0.85;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: linear-gradient(
        -270deg,
        rgba(11, 11, 18, 0) 40%,
        rgba(11, 11, 18, 0.5) 70%,
        rgba(11, 11, 18, 0.85) 100%
      ),
      linear-gradient(
        0deg,
        rgba(11, 11, 18, 0.9) 0%,
        rgba(11, 11, 18, 0.4) 20%,
        rgba(11, 11, 18, 0) 50%
      );
  }
}
</style>
